import { render } from "./works.vue?vue&type=template&id=01ee110b&scoped=true"
import script from "./works.vue?vue&type=script&lang=js"
export * from "./works.vue?vue&type=script&lang=js"

import "./works.vue?vue&type=style&index=0&id=01ee110b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ee110b"]])

export default __exports__